import { object, string, ref } from "yup";

export const UserSchema = object({
    name: string().required(),
    email: string().email(),
    picture_url: string().nullable().url(),
});

export const BasicInfoSchema = object({
    name: string().required().label("Display Name").max(100),
    given_name: string().nullable().label("Given Name").max(100),
    family_name: string().nullable().label("Family Name").max(100),
    email: string().email().required().label("Email").max(100),
    picture_url: string()
        .url()
        .nullable()
        .label("Profile Picture Url")
        .max(2048),
}).unknown(false);

export const EmailLoginSchema = object({
    email: string().email().required().label("Email").max(100),
    password: string().required().label("Password"),
});

export const EmailSignupSchema = object({
    email: string().email().required().label("Email").max(100),
    password: string().required().min(8).max(100).label("Password"),
    confirm_password: string()
        .required()
        .min(8)
        .max(100)
        .label("Confirm Password")
        .oneOf([ref("password"), null], "Passwords must match"),
});

export const ForgotPasswordSchema = object({
    email: string().email().required().label("Email").max(100),
});

export const ResetPasswordSchema = object({
    password: string().required().min(8).max(100).label("New Password"),
    confirm_password: string()
        .required()
        .min(8)
        .max(100)
        .label("Confirm Password")
        .oneOf([ref("password"), null], "Passwords must match"),
});

export const ChangePasswordSchema = object({
    current_password: string().required().label("Current Password"),
    new_password: string()
        .required()
        .min(8)
        .max(100)
        .label("New Password")
        .test(
            "not-same-as-current",
            "New password must be different from current password",
            function (value) {
                return value !== this.parent.current_password;
            }
        ),
    confirm_password: string()
        .required()
        .min(8)
        .max(100)
        .label("Confirm Password")
        .oneOf([ref("new_password"), null], "Passwords must match"),
});
